import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { Geolocation } from '@ionic-native/geolocation';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { WpApiProvider } from '../providers/wp-api/wp-api';
import { CarrelloProvider } from '../providers/carrello/carrello';
import { SmsAuthProvider } from '../providers/sms-auth/sms-auth';
import { LinkPagamentiProvider } from '../providers/link-pagamenti/link-pagamenti';
import { GeoPuntiRitiroProvider } from '../providers/geo-punti-ritiro/geo-punti-ritiro';


@NgModule({
	declarations: [
		MyApp
	],
	imports: [
		BrowserModule,
		HttpModule,
		IonicModule.forRoot(MyApp),
		IonicStorageModule.forRoot()
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp
	],
	providers: [
		StatusBar,
		SplashScreen,
		Geolocation,
		{provide: ErrorHandler, useClass: IonicErrorHandler},
		WpApiProvider,
		CarrelloProvider,
		SmsAuthProvider,
		{ provide: LOCALE_ID, useValue: 'it' },
    LinkPagamentiProvider,
    GeoPuntiRitiroProvider,
	]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts